import { render, staticRenderFns } from "./ReferQuote.vue?vue&type=template&id=a8722ed8&scoped=true"
import script from "./ReferQuote.vue?vue&type=script&lang=js"
export * from "./ReferQuote.vue?vue&type=script&lang=js"
import style0 from "./ReferQuote.vue?vue&type=style&index=0&id=a8722ed8&prod&scoped=true&lang=css"
import style1 from "./ReferQuote.vue?vue&type=style&index=1&id=a8722ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8722ed8",
  null
  
)

export default component.exports